// extracted by mini-css-extract-plugin
export default {"iconInInput":"FormSearchSav_iconInInput__9u45k","iconLinkLeft":"FormSearchSav_iconLinkLeft__eb3Y8","popoverContent":"FormSearchSav_popoverContent__sCJkp"};